import { inject, Injectable } from "@angular/core";
import { GoogleAnalyticsService } from "@shared-services/google-analytics.service";

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class GoogleAnalyticsHelper {
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  //Google Analytics Events
  //Session start
  static readonly eventNameSessionStart = "expert_session_start_im";
  static readonly eventCategorySessionStart = "Expert-Session-Start";
  static readonly eventActionSessionStart = " IM Session";
  static readonly eventLabelSessionStart = "";
  //Session end
  static readonly eventNameSessionEnd = "expert_session_end_im";
  static readonly eventCategorySessionEnd = "Expert-Session-End";
  static readonly eventActionSessionEnd = " IM Session";
  static readonly eventLabelSessionEnd = "";


  handleClickEvent(event: Event) {
    if (event?.target) {
      let eventTarget = (event?.target as HTMLElement);
      if (eventTarget) {
        let anchorItem: HTMLAnchorElement = null
        if (eventTarget?.nodeName === 'A') {
          anchorItem = eventTarget as HTMLAnchorElement;
        }
        else {
          //target can be element inside the <a>
          anchorItem = eventTarget?.closest('a') as HTMLAnchorElement;
        }

        if (anchorItem) {
          let eventTargetLocation = anchorItem.href;

          if (!eventTargetLocation) {
            // href not set use current URL
            eventTargetLocation = window?.location?.pathname;
          }
          else if (eventTargetLocation.charAt(0) === '#') {
            // href is a link to a location on the current page
            eventTargetLocation = window?.location?.pathname + eventTargetLocation;
          }

          let pageSectionVal = anchorItem.closest('[data-page-section]')?.getAttribute('data-page-section');
          let eventLabel = anchorItem.innerText;

          this.googleAnalyticsService?.emitClickEvent(eventLabel, eventTargetLocation, pageSectionVal);
        }
      }
    }
  }
}
